export default defineNuxtPlugin((nuxtApp) => {
  const { locale, setLocale } = nuxtApp.$i18n as {
    locale: { value: string };
    setLocale: (code: string) => Promise<void>;
  };

  const FORCED_LOCALE = "en";
  const COOKIE_NAME = "i18n_redirected";

  if (locale.value !== FORCED_LOCALE) {
    void setLocale(FORCED_LOCALE);
  }

  if (import.meta.client) {
    const current = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${COOKIE_NAME}=`));

    if (!current || !current.endsWith(`=${FORCED_LOCALE}`)) {
      const oneYear = 60 * 60 * 24 * 365;
      document.cookie = `${COOKIE_NAME}=${FORCED_LOCALE}; path=/; max-age=${oneYear}; SameSite=Lax`;
    }
  }
});
